import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Pin',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "25", viewBox: "0 0 24 25" }
      }, ctx.data]),
      [h("path", {
        attrs: { fill: "currentColor", "fill-rule": "evenodd", d: "M10 4.5v5a4.002 4.002 0 0 1-3 3.874v.126h6v8l-1 1-1-1v-6H5v-4h1a2 2 0 0 0 2-2v-5h2Z", "clip-rule": "evenodd" }
      }), h("path", {
        attrs: { fill: "currentColor", "fill-rule": "evenodd", d: "M19 11.5v4h-4v-2h2v-.126A4.002 4.002 0 0 1 14 9.5v-5h2v5a2 2 0 0 0 2 2h1Z", "clip-rule": "evenodd" }
      }), h("path", {
        attrs: { fill: "currentColor", d: "M6 2.5h12v2H6v-2Z" }
      })]
    );
  }
};